import { DefaultService } from '@/services/DefaultService';


export default class AssUsuarioEmpresaService extends DefaultService {
    constructor(http, router, env) {
		super(http, router, env);
	}

    findAllVendas(column, order, page, limit, situacao, idempresa, ...params) {
        return this._http.get( encodeURI(`${this._env}/ven/empresa/assusuarioempresa.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idempresa=${idempresa}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    findAllPromotor(column, order, page, limit, situacao, idempresa, ...params) {
        return this._http.get( encodeURI(`${this._env}/promotor/empresa/assusuarioempresa.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idempresa=${idempresa}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    findAllAgro(column, order, page, limit, situacao, idempresa, ...params) {
        return this._http.get( encodeURI(`${this._env}/agro/empresa/assusuarioempresa.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idempresa=${idempresa}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    findAllDespesas(column, order, page, limit, situacao, idempresa, ...params) {
        return this._http.get( encodeURI(`${this._env}/des/empresa/assusuarioempresa.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idempresa=${idempresa}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    updateSituacao(assusuarioempresa) {
        return this._http.post(`${this._env}/ven/empresa/assusuarioempresa/updatesituacao`, assusuarioempresa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacaoVendas(assusuarioempresa) {
        return this._http.post(`${this._env}/ven/empresa/assusuarioempresa/updatesituacao`, assusuarioempresa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacaoPromotor(assusuarioempresa) {
        return this._http.post(`${this._env}/promotor/empresa/assusuarioempresa/updatesituacao`, assusuarioempresa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacaoAgro(assusuarioempresa) {
        return this._http.post(`${this._env}/agro/empresa/assusuarioempresa/updatesituacao`, assusuarioempresa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacaoDespesas(assusuarioempresa) {
        return this._http.post(`${this._env}/des/empresa/assusuarioempresa/updatesituacao`, assusuarioempresa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findUsuariosNaoAssociadosVendas(column, order, page, limit, idempresa, ...params) {
        return this._http.get( encodeURI(`${this._env}/ven/empresa/assusuarioempresa/usuariosnaoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idempresa=${idempresa}&param=${params}`), this._headers ).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findUsuariosNaoAssociadosPromotor(column, order, page, limit, idempresa, ...params) {
        return this._http.get( encodeURI(`${this._env}/promotor/empresa/assusuarioempresa/usuariosnaoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idempresa=${idempresa}&param=${params}`), this._headers ).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findUsuariosNaoAssociadosAgro(column, order, page, limit, idempresa, ...params) {
        return this._http.get( encodeURI(`${this._env}/agro/empresa/assusuarioempresa/usuariosnaoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idempresa=${idempresa}&param=${params}`), this._headers ).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findUsuariosNaoAssociadosDespesas(column, order, page, limit, idempresa, ...params) {
        return this._http.get( encodeURI(`${this._env}/des/empresa/assusuarioempresa/usuariosnaoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idempresa=${idempresa}&param=${params}`), this._headers ).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveVendas(listausuarios) {
        return this._http.post(`${this._env}/ven/empresa/assusuarioempresa`, listausuarios, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    savePromotor(listausuarios) {
        return this._http.post(`${this._env}/promotor/empresa/assusuarioempresa`, listausuarios, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveAgro(listausuarios) {
        return this._http.post(`${this._env}/agro/empresa/assusuarioempresa`, listausuarios, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveDespesas(listausuarios) {
        return this._http.post(`${this._env}/des/empresa/assusuarioempresa`, listausuarios, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}